import { JobResponse } from '@doda/api-client/aspida/@types';

/**
 * 会社フルネーム生成
 * @param {JobResponse} job
 * @param tabState
 * @returns corporateName
 */
export const makeCorporateFullName = (job: JobResponse) => {
  // job.corporateNameが存在すれば、job.corporateName【job.marketName】(job.corporateGroupName)と表示する。
  if (!job.corporateName) return '';
  if (job.wcnsId === 'T') return job.corporateName;
  return (
    job.corporateName +
    (job.marketName ? `【${job.marketName}】` : '') +
    (job.corporateGroupName ? `(${job.corporateGroupName})` : '')
  );
};
